<template>
  <o-form-wrapper
    :form-state="formState"
    :schema="schema"
    :server-errors="_se"
    :v="$v.item"
    v-model="item"
  >
    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="section_type"
    >
      <o-select
        :form-state="formState"
        :items="optionsDocumentTypesItems"
        :server-errors="_se"
        :validators="$v.item"
        name="section_type"
        sort-field="description"
        text-field="description"
        v-bind="schema.fields.section_type"
        v-model="item.section_type"
        value-field="id"
      >
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="file"
      v-if="item.section_type == 1"
    >
      <o-file-input
        :form-state="formState"
        :other-id="item.id"
        :server-errors="_se"
        :validators="$v.item"
        name="file"
        other-name="document_template_section"
        show-preview
        v-bind="schema.fields.file"
        v-model="item.file"
      ></o-file-input>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="document_text"
      v-if="item.section_type == 2"
    >
      <o-textarea
        :form-state="formState"
        rows="15"
        :server-errors="_se"
        :validators="$v.item"
        name="document_text"
        v-bind="schema.fields.document_text"
        v-model="item.document_text"
      ></o-textarea>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="page_break"
    >
      <o-select
        :form-state="formState"
        :items="optionsPageBreakItems"
        :server-errors="_se"
        :validators="$v.item"
        name="page_break"
        sort-field="description"
        text-field="description"
        v-bind="schema.fields.page_break"
        v-model="item.page_break"
        value-field="id"
      >
      </o-select>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import DocumentTypes from "../../document_template/DocumentTypes";
import PageBreaks from "../../document_template/PageBreaks";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("DocumentTemplateSection"),
    CreateCodeTableFetchMixin([]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.DocumentTemplateSection, {}),

    optionsDocumentTypesItems: DocumentTypes,
    optionsPageBreakItems: PageBreaks,
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
